import CookieService from 'utils/miscUtils/CookieService';
import styled from 'styled-components';
import type { ConversionData } from 'services/Piano/entities/PianoCallbackParams';

const TrackerPixel = styled.img`
  height: 1px;
  width: 1px;
  display: none;
`;

interface ConversionParams {
  email: string;
  jobId: string;
  batchId: string;
  listId: string;
  jobUrlId: string;
  memberId: string;
  subId: string;
}

interface ConversionTrackerProps {
  conversionData: ConversionData;
  databaseId: string;
  title: string;
}

function buildConversionXML(params: string, conversionData: ConversionData, databaseId: string, title: string) {
  const { email, jobId, jobUrlId, batchId, listId, memberId, subId } = JSON.parse(params) as ConversionParams;
  const { price, currency } = conversionData;

  const xml = `
    <system>
      <system_name>tracking</system_name>
      <action>conversion</action>
      <member_id>${memberId}</member_id>
      <job_id>${jobId}</job_id>
      <email>${email}</email>
      <sub_id>${subId}</sub_id>
      <list>${listId}</list>
      <original_link_id>${jobUrlId}</original_link_id>
      <BatchID>${batchId}</BatchID>
      <conversion_link_id>${databaseId}</conversion_link_id>
      <link_alias>${title}</link_alias>
      <display_order>1</display_order>
      <data_set>
        <data amt="${price}" unit="${currency}" accumulate="true"/>
      </data_set>
    </system>
  `;
  return xml.replace(/^\s+/gm, '').replace(/\n/g, '');
}

const ConversionTracker = ({ conversionData, databaseId, title }: ConversionTrackerProps) => {
  let trackingLink;
  const savedParams = CookieService.get('sfconversionparams');

  if (savedParams) {
    const conversionXML = buildConversionXML(savedParams, conversionData, databaseId, title);
    trackingLink = `http://click.s13.exacttarget.com/conversion.aspx?xml=${encodeURIComponent(conversionXML)}`;
  }

  if (!trackingLink) {
    return null;
  }
  return <TrackerPixel src={trackingLink} />;
};

export default ConversionTracker;
